/** Detect phones and touch-first tablets (including desktop-mode iPads). */
export const isTouchMobile = (nav = globalThis.navigator) =>
  nav?.userAgentData?.mobile === true || nav?.maxTouchPoints > 1;
